import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { Helmet } from "react-helmet";

//CUSTOM COMPONENT
import Area from "../../aGlobalDesign/Area/Area";

import ZonesList from "./Zones/ZonesList";
import CallCentersList from "../CallGestion/CallCenters/CallCentersList";
import DecisionTreesList from "../CallGestion/DecisionTrees/DecisionTreesList";
import CallCategoriesList from "../CallGestion/CallCategories/CallCategoriesList";

class OrganisationContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            reloadKey: 0,
            createNew: 0,
            selectedPage: new URLSearchParams(new URL(window.location.href).search).get("selectedPage") ?
                new URLSearchParams(new URL(window.location.href).search).get("selectedPage")
                : this.props.currentuser?.accessrights?.hasPermission(50, "consult") > 10 ? "zones"
                    : this.props.currentuser?.accessrights?.hasPermission(60, "consult") > 10 ? "callcenters"
                        : this.props.currentuser?.accessrights.hasPermission(70, "consult") > 10 ? "decisiontrees"
                            : "callcategories"
        };
    }

    componentDidMount() {
        this.props.toggleOrganisationMenu();
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedZone: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    getNavigationList() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const list = [];
        if (accessrights && accessrights.hasPermission(50, "consult") > 10) {
            list.push({
                id: "zones",
                title: strings.Zones,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "zones",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(60, "consult") > 10) {
            list.push({
                id: "callcenters",
                title: strings.CallCenters,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "callcenters",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(70, "consult") > 10) {
            list.push({
                id: "decisiontrees",
                title: strings.DecisionTrees,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "decisiontrees",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(300, "consult") > 10) {
            list.push({
                id: "callcategories",
                title: strings.CallCategories,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "callcategories",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        return list;
    }
    getSideButtonsList() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const sb = {
            type: "primary-icon",
            nameIcon: "add",
            text: "Nouveau",
            onClick: () => this.setState({ createNew: this.state.createNew + 1 })
        };
        if (this.state.selectedPage == "zones" && accessrights && accessrights.hasPermission(50, "create") <= 10) {return [];}
        if (this.state.selectedPage == "callcenters" && accessrights && accessrights.hasPermission(60, "create") <= 10) {return [];}
        if (this.state.selectedPage == "decisiontrees" && accessrights && accessrights.hasPermission(70, "create") <= 10) {return [];}
        if (this.state.selectedPage == "callcategories" && accessrights && accessrights.hasPermission(300, "create") <= 10) {return [];}
        return [sb];
    }

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        return <>
            <Area
                helmet={strings.helmetOrganization }
                title={strings.Organization}
                navigatedId={this.state.selectedPage}
                navigation={this.getNavigationList()}
                sideButtons={this.getSideButtonsList()}
            >
                {
                    this.state.selectedPage == "zones" ? <ZonesList
                        reload={this.state.reload}
                        key={`zones-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "callcenters" ? <CallCentersList
                        reload={this.state.reload}
                        key={`callcenters-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "decisiontrees" ? <DecisionTreesList
                        reload={this.state.reload}
                        key={`decisiontrees-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "callcategories" ? <CallCategoriesList
                        reload={this.state.reload}
                        key={`callcategories-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }

            </Area>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(OrganisationContainer));
